export function paymentOptionLabel(option: string | null | undefined): string {
  if (!option) { return ''; }
  return option.split('_')
    .map(word => word === 'ach' ? 'ACH' : word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
